import { ofType } from 'redux-observable'
import { from } from 'rxjs'
import { catchError, mergeMap, switchMap } from 'rxjs/operators'

import ClientActions, { ClientTypes } from '../redux/ClientRedux'
import UserActions, { USER_TYPE } from '../redux/UserRedux'
import { type ApiEndpoints } from '../services/api'
import { type ReduxState } from '../store/reducers'
import { type TherapistType } from '../types/TherapistStateType'
import { generalErrorHandler, generalSuccessHandler } from './EpicHelpers'

export default class ClientEpic {
  static getTherapists = (api: ApiEndpoints) => (action$: any, state$: { value: ReduxState }) =>
    action$.pipe(
      ofType(ClientTypes.GET_THERAPISTS_REQUEST),
      mergeMap(() => {
        return from(api.getOpenTherapists()).pipe(
          mergeMap(({ data }: { data: TherapistType[] }) => {
            const user = state$.value.user
            const subscriptionTherapistIds =
              user.userSubscriptions?.map((subscription) => subscription.therapistId) || []
            const therapists = data.filter(
              (therapist) =>
                therapist.visible ||
                user.visitedTherapistIds.includes(therapist.therapistId) ||
                subscriptionTherapistIds.includes(therapist.therapistId),
            )
            return from([
              ClientActions.onChangeClientValue('therapists', therapists),
              ClientActions.onChangeClientValue('freeTherapists', therapists),
              generalSuccessHandler('', 'therapists'),
            ])
          }),
          catchError(generalErrorHandler('therapists')),
        )
      }),
    )

  static cancelPrebookedEvents = (api: ApiEndpoints) => (action$: any) =>
    action$.pipe(
      ofType(ClientTypes.CANCEL_PREBOOKED_EVENTS_REQUEST),
      switchMap(({ eventsId }) =>
        from(api.cancelPrebookedEvents(eventsId)).pipe(
          mergeMap(() => from([UserActions.getAllEventsRequest(USER_TYPE.CLIENT)])),
          catchError(generalErrorHandler()),
        ),
      ),
    )

  static getAllActions = ({ api }: { api: ApiEndpoints }) => [
    ClientEpic.getTherapists(api),
    ClientEpic.cancelPrebookedEvents(api),
  ]
}
